<template>
    <v-container>
        <v-tabs v-model="tab">
            <v-tab>Datos personales</v-tab>
            <v-tab>Dirección</v-tab>
            <v-tab>Datos de contabilidad</v-tab>
            <v-tab v-if="user.idRol == 1">Configuración</v-tab>
            <v-tab v-if="user.id != null">Incidencias</v-tab>
            <v-tab v-if="user.id != null">Vacaciones</v-tab>
            <v-tab v-if="user.id != null">Formaciones</v-tab>

            <slot name="tab-headers"></slot>

            <!-- Datos personales -->
            <v-tab-item>
                <v-row>
                    <v-col cols="12" md="3">
                        <v-text-field
                            v-model="user.name"
                            label="Nombre y apellidos"
                            :rules="required_val"
                            required
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="3" v-if="!agente">
                        <v-autocomplete
                            v-model="user.idRol"
                            :items="roles"
                            item-text="descripcion"
                            item-value="id"
                            label="Roles"
                            :rules="required_val"
                            required
                        >
                        </v-autocomplete>
                    </v-col>
                    <v-col cols="12" md="3">
                        <v-autocomplete
                            v-model="user.id_empresa"
                            :items="sociedades"
                            item-text="nombre"
                            item-value="id"
                            label="Empresa"
                            placeholder="Asociar una empresa a este empleado"
                        ></v-autocomplete>
                    </v-col>

                    <v-col cols="12" md="3">
                        <date-select
                            label="Fecha de alta"
                            v-model="user.fecha_alta"
                        />
                    </v-col>
                    <v-col cols="12" md="3">
                        <date-select
                            label="Fecha de baja"
                            v-model="user.fecha_baja"
                        />
                    </v-col>

                    <v-col cols="12" md="3">
                        <v-text-field
                            v-model="user.dni"
                            label="DNI"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="3">
                        <v-text-field
                            v-model="user.email"
                            label="Email de trabajo (credienciales de ingreso)"
                            :rules="required_val"
                            required
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="3">
                        <v-text-field
                            v-model="user.email_trabajo"
                            label="Email personal"
                        ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="3">
                        <v-text-field
                            v-model="user.telefono_personal"
                            label="Teléfono"
                        ></v-text-field>
                    </v-col>
                    <!-- <v-col cols="12" md="3">
                        <v-text-field
                            v-model="user.telefono_comercial"
                            label="Teléfono de trabajo"
                        ></v-text-field>
                    </v-col> 
                    <v-col cols="12" md="3">
                        <v-text-field
                            v-model="user.nro_hijos"
                            type="number"
                            label="Número de hijos"
                        ></v-text-field>
                    </v-col> -->
                    <v-col cols="12" md="3">
                        <v-text-field
                            v-model="user.estudios"
                            label="Categoría I"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="8">
                        <v-text-field
                            v-model="user.lugar_nacimiento"
                            label="Lugar de nacimiento"
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                        <v-textarea
                            outlined
                            label="Observaciones"
                            v-model="user.observaciones"
                        ></v-textarea>
                    </v-col>
                </v-row>
            </v-tab-item>

            <!-- Dirección -->
            <v-tab-item>
                <v-row>
                    <v-col cols="12">
                        <v-text-field
                            v-model="user.direccion.calle"
                            label="Dirección"
                            required
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                        <v-text-field
                            v-model="user.direccion.localidad"
                            label="Localidad"
                            required
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-text-field
                            v-model="user.direccion.cp"
                            type="number"
                            label="Código postal"
                            required
                        ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="6">
                        <v-autocomplete
                            v-model="user.direccion.idProvincia"
                            :items="provincias"
                            item-text="nombre"
                            item-value="id"
                            label="Provincias"
                        >
                        </v-autocomplete>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-autocomplete
                            v-model="user.direccion.id_pais"
                            :items="paises"
                            item-text="nombre"
                            item-value="id"
                            label="País"
                        >
                        </v-autocomplete>
                    </v-col>
                </v-row>
            </v-tab-item>

            <!-- Datos de contabilidad -->
            <v-tab-item>
                <v-row>
                    <!-- No mostrar al rol dpto. tecnico-->
                    <v-col cols="12" md="4" v-if="rol != 9">
                        <v-text-field
                            v-model="user.sueldo"
                            type="number"
                            label="Sueldo"
                            required
                        ></v-text-field>
                    </v-col>
                    <!-- <v-col cols="12" md="4">
                        <v-text-field
                            v-model="user.seg_social"
                            label="Seguridad social"
                            required
                        ></v-text-field>
                    </v-col> 
                    <v-col cols="12" md="4">
                        <v-text-field
                            v-model="user.empresa"
                            label="Empresa"
                            required
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-text-field
                            v-model="user.trabajador"
                            label="Trabajador"
                            required
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-text-field
                            v-model="user.irpf"
                            label="IRPF"
                            required
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-text-field
                            v-model="user.jornada"
                            label="Jornada semanal (horas)"
                            required
                        ></v-text-field>
                    </v-col> -->
                    <v-col cols="12" md="4">
                        <v-text-field
                            v-model="user.hora"
                            label="Hora"
                            required
                        ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="4">
                        <v-text-field
                            v-model="user.hora_coste"
                            label="Hora coste"
                            @input="
                                user.hora_coste = inputPrice(user.hora_coste)
                            "
                            suffix="€"
                            required
                        ></v-text-field>
                    </v-col>

                    <!-- No mostrar al rol dpto. tecnico-->
                    <v-col cols="12" md="4" v-if="rol != 9">
                        <v-text-field
                            v-model="user.hora_extra"
                            label="Hora nocturna"
                            required
                        ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="4">
                        <v-text-field
                            v-model="user.hora_extra_coste"
                            label="Hora nocturna coste"
                            @input="
                                user.hora_extra_coste = inputPrice(
                                    user.hora_extra_coste
                                )
                            "
                            suffix="€"
                            required
                        ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="4">
                        <v-text-field
                            v-model="user.plus"
                            label="Plus"
                            type="number"
                            suffix="€"
                        ></v-text-field>
                    </v-col>

                    <!-- <v-col cols="12" md="4">
                        <v-text-field
                            v-model="user.precio_km"
                            label="Precio Km"
                            required
                        ></v-text-field>
                    </v-col> -->
                    <v-col cols="12" md="4">
                        <v-text-field
                            v-model="user.cuenta_bancaria"
                            label="Cuenta bancaria"
                            required
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4"> </v-col>
                    <v-col cols="12">
                        <v-divider />
                        <h5 class="mt-3">Horas de la jornada laboral</h5>
                    </v-col>
                    <v-col cols="12" md="1">
                        <v-text-field
                            v-model="user.horas_jornada_lunes"
                            label="Lunes"
                            required
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="1">
                        <v-text-field
                            v-model="user.horas_jornada_martes"
                            label="Martes"
                            required
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="1">
                        <v-text-field
                            v-model="user.horas_jornada_miercoles"
                            label="Miércoles"
                            required
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="1">
                        <v-text-field
                            v-model="user.horas_jornada_jueves"
                            label="Jueves"
                            required
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="1">
                        <v-text-field
                            v-model="user.horas_jornada_viernes"
                            label="Viernes"
                            required
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="1">
                        <v-text-field
                            v-model="user.horas_jornada_sabado"
                            label="Sábado"
                            required
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="1">
                        <v-text-field
                            v-model="user.horas_jornada_domingo"
                            label="Domingo"
                            required
                        ></v-text-field>
                    </v-col>
                    <v-col cols="12"></v-col>
                    <v-col cols="12" md="5">
                        <v-btn
                            @click="$emit('open', user)"
                            class="white--text mt-5"
                            color="blue"
                            small
                            dense
                            depressed
                            >Entrega de materiales</v-btn
                        >
                    </v-col>
                </v-row>
            </v-tab-item>

            <!-- Configuración -->
            <v-tab-item v-if="user.idRol == 1">
                <v-row>
                    <v-col cols="12" md="4">
                        <v-switch
                            label="Recibir email potenciales"
                            v-model="user.send_mail"
                            :true-value="1"
                            :false-value="0"
                        >
                        </v-switch>
                    </v-col>
                </v-row>
            </v-tab-item>

            <!-- Incidencias -->
            <v-tab-item v-if="user.id != null">
                <TabIncidencia :usuario="user"></TabIncidencia>
            </v-tab-item>

            <!-- Vacaciones -->
            <v-tab-item v-if="user.id != null">
                <Vacaciones :user="user"></Vacaciones>
            </v-tab-item>

            <!-- Formaciones -->
            <v-tab-item v-if="user.id != null">
                <Formaciones :userId="user.id" />
            </v-tab-item>
            <slot name="tab-items"></slot>
        </v-tabs>

        <entrega-materiales
            v-on:update_items="updateItems"
        ></entrega-materiales>
    </v-container>
</template>
<script>
import TabIncidencia from "./TabIncidencia.vue";
import Vacaciones from "./Vacaciones.vue";
import EntregaMateriales from "./EntregaMateriales.vue";
import { formatPrice, inputPrice, parseEuroNumber } from "../../../helpers";
import dateSelect from "../../../components/general/dateSelect.vue";
import Formaciones from "./FormacionesTab.vue";

export default {
    props: ["value", "agente"],
    components: {
        TabIncidencia,
        Vacaciones,
        EntregaMateriales,
        dateSelect,
        Formaciones,
    },
    data() {
        return {
            readonly: true,
            tab: 0,
            provincias: [],
            paises: [],
            sociedades: [],
            user: {
                id: null,
                idRol: null,
                id_empresa: null,
                direccion: {},
                entrega_material: [],
                hora_coste: 0,
                hora_extra_coste: 0,
                plus: null,
            },
            nueva: 0,
            required_val: [(v) => !!v || "El campo es requerido"],
            cliente: {
                cuenta: null,
            },
        };
    },
    mounted() {
        this.user = this.value;
        this.getPaises();
        this.getProvincias();
        this.getCuentas();
        this.getSociedades();
    },
    methods: {
        updateItems(items) {
            this.user.entrega_material = items;
        },
        getCuentas() {
            let prefix = 640;
            axios.get(`api/get-cuentas/${prefix}`).then(
                (res) => {
                    this.cuentas = res.data.success;

                    let numero = 0;
                    this.cuentas.forEach((element) => {
                        if (numero < element.numero) {
                            numero = element.numero;
                        }
                    });

                    this.cliente.cuenta = parseInt(numero) + 1;
                },
                (res) => {}
            );
        },
        getProvincias() {
            axios.get(`api/getprovincias`).then(
                (res) => {
                    this.provincias = res.data;
                },
                (res) => {}
            );
        },
        getPaises() {
            axios.get(`api/get-paises`).then(
                (res) => {
                    this.paises = res.data;
                },
                (res) => {}
            );
        },
        getSociedades() {
            axios.get(`api/get-sociedades`).then(
                (res) => {
                    this.sociedades = res.data;
                },
                (res) => {}
            );
        },
        formatPrice,
    },
    watch: {
        value(val) {
            this.user = this.value;
            this.user.hora_coste = formatPrice(this.user.hora_coste);
            this.user.hora_extra_coste = formatPrice(
                this.user.hora_extra_coste
            );
        },
        user: {
            deep: true,
            handler() {
                if (this.user.direccion == null) {
                    this.user.direccion = {};
                }
                this.$emit("input", this.user);
            },
        },
    },
    computed: {
        isloading() {
            return this.$store.getters.getloading;
        },
        roles() {
            return this.$store.getters.getroles;
        },
        rol() {
            return localStorage.getItem("role");
        },
    },
};
</script>
